import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  ScreenContainer, CommonPagination,
} from '../../CommonComponents';
import DashUserTable from './DashUserTable';
import {
  getDashUsers, createDashUser, showUserForm,
} from '../../redux/actions/dashusers';
import {
  getCompanies,
} from '../../redux/actions/common';
import DashUserCreation from '../../CommonComponents/DashUserCreation';
import CommonButton from '../../CommonComponents/CommonButton';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const DashUser = ({
  createDUser,
  getUsers,
  userForm,
  showForm,
  totalDashUserPages,
  getFilters,
}) => {
  const query = useQuery();
  const page = parseInt(query.get('page') || '1', 10);

  useEffect(() => {
    getUsers(page);
    getFilters();
  }, [getUsers, page, getFilters]);

  const createUser = (fields) => {
    const data = { ...fields }
    createDUser(data);
  }

  return (
    <ScreenContainer title="Product Managers">
      <CommonButton
        variant="outlined"
        color="primary"
        onClick={() => showForm(1)}
      >
        Add User
      </CommonButton>
      <br />
      <br />
      <DashUserTable />
      {totalDashUserPages > 1 ? (
        <CommonPagination
          baseUrl="dash-users"
          totalPages={totalDashUserPages}
        />
      ) : null}
      {userForm === 1
        ? (
          <DashUserCreation
            userType="manager"
            setModal={showForm}
            createUser={createUser}
            title="Add Manager"
          />
        )
        : null}
    </ScreenContainer>
  );
}

const mapState = (state) => ({
  userForm: state.dashusers.showUserForm,
  totalDashUserPages: state.dashusers.totalDashUserPages,
});

const mapActions = {
  createDUser: createDashUser,
  getUsers: getDashUsers,
  showForm: showUserForm,
  getFilters: getCompanies,
};

export default connect(mapState, mapActions)(DashUser);
